import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from '../../visit-context';

@Component({
    selector: 'app-timeline-icon',
    templateUrl: './timeline-icon.component.html',
    styleUrls: ['./timeline-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimelineIconComponent {

  context = VisitContext;

  @Input() shipStatus: string;
}
